export default __webpack_public_path__ + "static/media/viber_image_2022-06-04_14-35-10-168.a22de0fb.jpg";